import { countryFlag } from "@/lib/api";
import { Cloud, ListTree, Server, Globe, ChevronRight } from "lucide-react";

function Node({ icon: Icon, label, sub, active, accent }) {
  return (
    <div
      className={`relative flex flex-col items-center text-center gap-2 px-3 py-4 min-w-[118px] border transition-colors duration-150 ${
        active ? "border-neon bg-neon/5 neon-glow" : accent ? "border-laser/40 bg-laser/5" : "border-line bg-black/40"
      }`}
    >
      <Icon size={20} className={active ? "text-neon" : accent ? "text-laser" : "text-dim"} />
      <span className="overline !text-[9px]">{label}</span>
      <span className={`font-mono text-xs ${active ? "text-neon" : "text-foreground"}`}>{sub}</span>
    </div>
  );
}

function Arrow() {
  return <ChevronRight className="text-line shrink-0" size={22} />;
}

export default function ArchitectureFlow({ active, gateway }) {
  const gwPort = gateway?.port ? `:${gateway.port}` : ":8080";
  return (
    <div className="card-panel h-full p-5 grid-lines relative overflow-hidden" data-testid="architecture-flow">
      <div className="flex items-center justify-between mb-4">
        <div>
          <span className="overline">Pipeline</span>
          <h3 className="font-heading text-lg tracking-tight">Proxy Gateway Flow</h3>
        </div>
        <span className="font-mono text-[10px] text-dim">FLOPPYDATA → YOUR WEB</span>
      </div>
      <div className="flex items-center gap-2 overflow-x-auto pb-2">
        <Node icon={Cloud} label="Source" sub="FloppyData" />
        <Arrow />
        <Node icon={ListTree} label="Proxy List" sub="IP Pool" />
        <Arrow />
        <Node
          icon={Globe}
          label="Selected Proxy"
          sub={active ? `${countryFlag(active.country)} ${active.exit_ip || active.country || "—"}` : "not selected"}
          active={!!active}
        />
        <Arrow />
        <Node icon={Server} label="Proxy Server" sub={gateway?.running ? `${gwPort} · live` : gwPort} accent />
        <Arrow />
        <Node icon={Globe} label="Your Web" sub="output" />
      </div>
      <p className="mt-3 text-xs text-dim font-mono">
        {active
          ? `Traffic forwarded via ${active.type} · ${active.host}:${active.port}${gateway?.running ? ` · gateway ${gwPort} (${gateway.connections} connections, ${((gateway.bytes_down || 0) / 1024).toFixed(1)} KB)` : ""}`
          : "Select a proxy from the list to activate the gateway."}
      </p>
    </div>
  );
}
